import {useResourceList} from '@karpeleslab/klb-react-services';

export const useOrderAffiliates = (restSettings = null) => useResourceList('Order/Affiliate', restSettings);